import React from 'react';
import i18next from 'i18next';
import Icon from '../Icon/Icon';
import InputText from '../InputText/InputText';
import { numberWithSpaces } from '../../utils';

import plusIcon from 'icons/plus-white.svg';
import minusIcon from 'icons/minus-white.svg';

export default class SumInput extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      start: null,
      holding: false,
    };

    this._timer = null;
    this._unmounted = false;
    this.started_at = 0;
  }

  static defaultProps = {
    min: 10,
    max: 50000,
    showMinMax: true,
  };

  componentWillUnmount() {
    this._unmounted = true;
    clearTimeout(this._timer);
    this._timer = null;
  }

  onPress = (sign) => {
    const { sum, min, max } = this.props;

    let step;
    if (sign > 0) {
      step = sum < 50 ? 10 : sum < 500 ? 50 : 100;
    } else {
      step = sum <= 50 ? 10 : sum <= 500 ? 50 : 100;
    }

    let newSum = sum + step * sign;

    newSum = Math.round(newSum / 10) * 10;

    const reachedMax = newSum > max;
    const reachedMin = newSum < min;

    if (reachedMin && newSum <= sum) {
      newSum = min;
    }
    if (reachedMax && newSum >= sum) {
      newSum = max;
    }

    this.props.onChange(newSum);
  };

  onInputChange = (e) => {
    e.preventDefault();

    const newSum = +e.currentTarget.value;
    if (Number.isInteger(newSum)) {
      this.props.onChange(newSum);
    }
  };

  onInputBlur = (e) => {
    const newSum = +e.currentTarget.value;
    if (newSum < this.props.min) {
      this.props.onChange(this.props.min);
    }
    if (newSum > this.props.max) {
      this.props.onChange(this.props.max);
    }
  };

  start = (sign) => {
    if (+new Date() - this.started_at > 300) {
      this.started_at = +new Date();

      this.setState({ holding: true });

      this.onPress(sign);
      this._timer = setTimeout(() => {
        this._timer = setInterval(this.onPress.bind(this, sign), 100);
      }, 300);

      document.documentElement.addEventListener('mouseup', this.end);
    }
  };

  end = (e) => {
    document.documentElement.removeEventListener('mouseup', this.end);
    if (this._unmounted) {
      return false;
    }

    clearTimeout(this._timer);

    this.setState({ start: null, holding: false });
  };

  render() {
    const { sum, showMinMax } = this.props;
    const reachedMax = sum >= this.props.max;
    const reachedMin = sum <= this.props.min;

    return (
      <div className="sum-input">
        <span className="sum-input__title">{i18next.t('sum_input.enter')}</span>
        <div className="sum-input__fields">
          <div
            className={
              `sum-input__button sum-input__button--minus` +
              (reachedMin ? ' disabled' : '')
            }
            onMouseDown={this.start.bind(this, -1)}
            onTouchStart={this.start.bind(this, -1)}
            onMouseUp={this.end}
            onTouchCancel={this.end}
            onTouchEnd={this.end}
          >
            <Icon glyph={minusIcon} />
          </div>
          <div className="sum-input__input-wrapper">
            <InputText
              name="sum"
              placeholder=""
              className="sum-input__input"
              value={sum}
              onChange={this.onInputChange}
              onBlur={this.onInputBlur}
              autoComplete="off"
            />
          </div>
          <div
            className={
              `sum-input__button sum-input__button--plus` +
              (reachedMax ? ' disabled' : '')
            }
            onMouseDown={this.start.bind(this, 1)}
            onTouchStart={this.start.bind(this, 1)}
            onMouseUp={this.end}
            onTouchCancel={this.end}
            onTouchEnd={this.end}
          >
            <Icon glyph={plusIcon} />
          </div>
        </div>
        {showMinMax && (
          <div className="sum-input__min-max">
            <div>
              {i18next.t('sum_input.min')} <span>{numberWithSpaces(this.props.min)}</span>
            </div>
            <div>
              {i18next.t('sum_input.max')} <span>{numberWithSpaces(this.props.max)}</span>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/SumInput/SumInput.jsx